var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.341 58.7036L101.498 42.5379C101.057 42.3913 100.616 42.3913 100.175 42.3913C99.7346 42.3913 99.4404 42.3913 98.9996 42.5379L42.4213 58.7036C41.0989 58.9978 40.2174 60.1736 40.2174 61.4961V139.383C40.2174 140.705 41.099 141.881 42.4213 142.175L98.9996 158.341C99.2938 158.488 99.587 158.488 99.7346 158.488H100.029H100.47C100.764 158.488 101.057 158.488 101.351 158.341L157.195 142.175C158.517 141.881 159.252 140.705 159.252 139.383L159.251 61.4961C159.399 60.1737 158.516 58.9979 157.341 58.7036V58.7036ZM76.6621 79.1306L63.583 82.0695V58.7036L76.6621 55.0297V79.1306ZM153.52 137.178L103.555 151.58V49.2982L153.52 63.6996V137.178Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.72 120.278H120.308L140.881 115.869C142.203 115.575 143.233 114.399 143.233 112.931L143.234 83.5393C143.234 82.0693 142.204 80.8946 140.736 80.6004L120.162 77.6616C119.281 77.515 118.399 77.8081 117.811 78.3965C117.222 78.9839 116.781 79.7179 116.781 80.6005V117.34C116.781 118.221 117.222 119.103 117.811 119.691C118.398 119.984 118.986 120.279 119.72 120.279V120.278ZM122.66 83.9802L137.356 86.0375V110.433L122.66 113.519V83.9802Z",
    fill: "#B7B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.9baa184f3b5b76290987e2060b7b5410.svg";
export { ForwardRef as ReactComponent };